import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11375a61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-between items-center status-bar-license-title-container" }
const _hoisted_2 = { class: "sbli--title gordita-500-14-m" }
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = {
  key: 1,
  class: "cloud-icon text-Text/text_low"
}
const _hoisted_5 = {
  key: 0,
  class: "gordita-400-11 flex justify-between"
}
const _hoisted_6 = {
  key: 0,
  "data-testid": "cloud-license-trial-expiration-date"
}
const _hoisted_7 = {
  key: 1,
  class: "total-info-big sans-700-16"
}
const _hoisted_8 = { style: {"max-width":"232px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

import { computed, ref } from 'vue';
import millify from 'millify';
import { CLOUD_LICENSE_STATUSES, CLOUD_LICENSE_TYPES } from '@/components/status-bar/components/CONST';
import { useI18n } from 'vue-i18n';
import { dateUtils } from '@/services/dateUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'status-bar-cloud-license-info',
  props: {
    size: null,
    cloudLicense: null,
    numOfBlocks: null
  },
  setup(__props: any) {

const props = __props as {
  size: string;
  cloudLicense: any;
  numOfBlocks: number;
}

const { t } = useI18n();
const elSize = ref({ width: null, height: null });
const handleResize = (value: any) => {
  elSize.value = value;
};


const expirationDate = computed(() => dateUtils.getFormattedDate(props.cloudLicense?.expirationDate));

const isCloudLicenseTrial = computed(() => props.cloudLicense?.licenseType?.toLowerCase() === CLOUD_LICENSE_TYPES.Trial);

const getBlockData = computed(() => {
  if (!props.cloudLicense) {
    // No cloud license data
    return {
      testId: 'status-bar-cloud-license-unavailable',
      title: t('dashboard.top.topRightBars.cloudLicense.cloudUnavailable.title'),
      icon: t('dashboard.top.topRightBars.cloudLicense.cloudUnavailable.icon'),
      description: '',
      tooltip: '',
    };
  }
  if (props.cloudLicense?.licenseStatus?.toLowerCase() === CLOUD_LICENSE_STATUSES.Expired) {
    // Expired
    return {
      testId: 'status-bar-cloud-license-expired',
      title: t('dashboard.top.topRightBars.cloudLicense.cloudExpired.title'),
      icon: t('dashboard.top.topRightBars.cloudLicense.cloudExpired.icon'),
      description: t('dashboard.top.topRightBars.cloudLicense.cloudExpired.description'),
      tooltip: t('dashboard.top.topRightBars.cloudLicense.cloudExpired.tooltip'),
    };
  }
  if (props.cloudLicense?.licenseStatus?.toLowerCase() === CLOUD_LICENSE_STATUSES.Disabled) {
    // Locked
    return {
      testId: 'status-bar-cloud-license-locked',
      title: t('dashboard.top.topRightBars.cloudLicense.cloudLocked.title'),
      icon: t('dashboard.top.topRightBars.cloudLicense.cloudLocked.icon'),
      description: t('dashboard.top.topRightBars.cloudLicense.cloudLocked.description'),
      tooltip: t('dashboard.top.topRightBars.cloudLicense.cloudLocked.tooltip'),
    };
  }
  if (isCloudLicenseTrial.value) {
    // Trial
    return {
      testId: 'status-bar-cloud-license',
      title: t('dashboard.top.topRightBars.cloudLicense.cloudTrial.title'),
      icon: '',
      description: t('dashboard.top.topRightBars.cloudLicense.cloudTrial.description'),
      tooltip: `${t('dashboard.top.topRightBars.cloudLicense.cloudTrial.description')} ${expirationDate.value}`,
    };
  }
  return {
    testId: 'cloud-license-unavailable',
    title: t('dashboard.top.topRightBars.cloudLicense.cloudUnavailable.title'),
    icon: t('dashboard.top.topRightBars.cloudLicense.cloudUnavailable.icon'),
    description: '',
    tooltip: '',
  };
});

const totalLicenseConsumptionFormatted = computed(() =>
  props.cloudLicense?.totalLicenseConsumption || props.cloudLicense?.totalLicenseConsumption === 0 ? Number(props.cloudLicense?.totalLicenseConsumption) : 0,
);
const totalCacheConsumptionFormatted = computed(() =>
  props.cloudLicense?.totalCacheConsumption || props.cloudLicense?.totalCacheConsumption === 0 ? Number(props.cloudLicense?.totalCacheConsumption) : 0,
);

const totalLicenseConsumption = computed(() => Math.ceil((totalLicenseConsumptionFormatted.value + totalCacheConsumptionFormatted.value) / 60));

const compactNumFormat = computed(
  () =>
    // Applying compact number format for 5 block in medium size
    props.numOfBlocks === 5 && props.size === 'medium',
);

return (_ctx: any,_cache: any) => {
  const _component_q_resize_observer = _resolveComponent("q-resize-observer")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`status-bar-license-info status-bar-license-info-${props.size}`),
    "data-testid": "status-bar-cloud-block"
  }, [
    _createVNode(_component_q_resize_observer, { onResize: handleResize }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getBlockData)?.title), 1),
        (_unref(isCloudLicenseTrial) && props.cloudLicense?.licenseStatus?.toLowerCase() === _unref(CLOUD_LICENSE_STATUSES).Active)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sbli--subtitle sans-700-26 text-no-wrap",
              "data-testid": _unref(getBlockData).testId
            }, _toDisplayString(_unref(compactNumFormat) ? _unref(millify)(_unref(totalLicenseConsumption)) : _unref(totalLicenseConsumption)), 9, _hoisted_3))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("i", {
                class: _normalizeClass(`incredicon-${_unref(getBlockData)?.icon}`)
              }, null, 2)
            ]))
      ])
    ]),
    (props.size !== 'small')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_unref(getBlockData)?.description), 1),
          (_unref(isCloudLicenseTrial) && props.cloudLicense?.licenseStatus?.toLowerCase() === _unref(CLOUD_LICENSE_STATUSES).Active)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(expirationDate)), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(isCloudLicenseTrial) && props.cloudLicense?.licenseStatus?.toLowerCase() === _unref(CLOUD_LICENSE_STATUSES).Active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(totalLicenseConsumption)), 1))
      : _createCommentVNode("", true),
    (props.size === 'small' && _unref(getBlockData)?.tooltip)
      ? (_openBlock(), _createBlock(_component_q_tooltip, {
          key: 2,
          class: "tooltip-background flex gordita-400-11",
          "data-testid": "status-bar-cloud-block-tooltip",
          style: {"padding":"8px 12px 8px 12px","border-radius":"2px"},
          delay: 300
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getBlockData)?.tooltip), 1),
            _hoisted_9
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})